import { Avatar, AvatarFallback, AvatarImage } from '@e2n/ui';

export function renderAvatar(
  imageUrl: string | null,
  vorname: string,
  nachname: string,
) {
  const initials = `${vorname[0].toUpperCase()}${nachname[0].toUpperCase()}`;

  return (
    <Avatar className="p-[6px] text-xs">
      {imageUrl ? (
        <AvatarImage className="rounded-full bg-neutrals-200" src={imageUrl} />
      ) : (
        <AvatarFallback className="p-[6px] rounded-full bg-neutrals-200">
          {initials}
        </AvatarFallback>
      )}
    </Avatar>
  );
}
